<template>
  <popup
    :opened="confirmActivateTemplate > -1"
    @close="close"
  >
    <!-- Screen to ask a confirmation to close current evaluation -->
    <div v-if="confirmActivateTemplate == 0">
      <div class="my-5 xl:my-15">
        <h3 class="mb-5 md:mb-10 2xl:mb-15">
          Activer le modèle de page "{{ templateNameToDeactivate }}"
        </h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            Êtes-vous sûr de vouloir activer le modèle de page "{{ templateNameToDeactivate }}" ?
          </p>
        </div>

        <div class="flex justify-center bg-pink">
          <action-button
            class="mr-4"
            border-color="border-pink-600"
            text-color="text-pink-600"
            bg-color="bg-pink-300"
            libelle="ANNULER"
            @clickAction="close(-1);"
          />
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            :uppercase="true"
            libelle="Activer"
            type-shadow="shadow-pink"
            @clickAction="confirm_activate_template()"
          />
        </div>
      </div>
    </div>
    <!-- END Screen to ask a confirmation to close current evaluation -->

    <!-- Screen to confirm the close -->
    <div v-if="confirmActivateTemplate == 1">
      <h3 class="w-full text-indigo-600 mt-12 mb-10">
        Le modèle de page "{{ templateNameToDeactivate }}"<br>a bien été activé !
      </h3>
      <illustration
        name="basket"
        class="  w-full m-5"
      />
    </div>
    <!-- END Screen to confirm the close -->
  </popup>
</template>

<script>
import Popup from './../Popup';
import ActionButton from './../ActionButton';
import Illustration from './../Illustration';
import Icon from './../Icon';

export default {
  components:{
    Popup,
    ActionButton,
    Illustration,
    Icon
  },

  props:{
    confirmActivateTemplate:{
      type: Number,
      required: false,
      default:-1,
    },
    templateNameToDeactivate:{
      type: String,
      required: false,
      default: '',
    },
  },

  methods:{
    confirm_activate_template(){
      this.$emit('confirm_activate_template');
    },
    close(){
      this.$emit('close');
    }
  }
};
</script>
